import {ComponenteKitMontagemComponent} from './componente-kit-montagem.component';
import {RegrasDeComponenteKit, permiteMultiplaEscolha} from '../../../../server/domain/kit/RegrasDeComponenteKit';
import {Component, Input, OnChanges, Output, EventEmitter} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RegrasDeKit} from '../../../../server/domain/kit/RegrasDeKit';

@Component({
  selector: 'app-kit-montagem', standalone: true, imports: [CommonModule, FormsModule, ComponenteKitMontagemComponent],
  templateUrl: './kit-montagem.component.html', styleUrls: ['./kit-montagem.component.scss']
})
export class KitMontagemComponent implements OnChanges {
  @Input() item: any;
  @Output() alterou = new EventEmitter<void>();
  aviso = '';
  get componentes(): any[] { return RegrasDeComponenteKit.grupos(this.item?.produto); }
  get produto(): any { return this.item.produto; }
  get config(): any { return this.produto.configKit; }
  get grupo(): any { return RegrasDeKit.grupo(this.produto); }
  get opcoes(): any[] { return (this.grupo?.opcoesDisponiveis || []).filter((o: any) => o.disponivel !== false && !o.esconder && !o.oculta); }
  get tamanhos(): any[] { return (this.produto.tamanhos || []).filter((t: any) => t.disponivel !== false); }
  get lista(): any {
    const i = (this.produto.camposAdicionais || []).filter((g: any) => g.tipo === 'multipla-escolha').indexOf(this.grupo);
    this.item.adicionais = this.item.adicionais || {};
    const lista = this.item.adicionais['lista' + i] || (this.item.adicionais['lista' + i] = {});
    lista.tipoDeCobranca = 'SOMA';
    lista.multiplicaQuantidadeProduto = true;
    return lista;
  }
  get total(): number { return this.opcoes.reduce((s, o) => s + this.quantidade(o), 0); }
  get erro(): string { return RegrasDeKit.erroDoItemTela(this.item)?.mensagem || ''; }
  get restante(): number { return (this.item.qtdeUnidadesKit || 0) - this.total; }
  get passoRapido(): number {
    const n = this.item.qtdeUnidadesKit || 0;
    return n >= 50 ? 10 : n >= 20 ? 5 : 1;
  }
  get progresso(): number {
    const n = this.item.qtdeUnidadesKit || 0;
    return n ? Math.min(100, Math.round(this.total / n * 100)) : 0;
  }
  get limiteAtingido(): boolean { return this.config.qtdeMaximaCompra != null && this.item.qtdeUnidadesKit + this.config.incrementoCompra > this.config.qtdeMaximaCompra; }
  /** Todos os grupos têm quantidade fixa: para levar mais, o cliente aumenta a quantidade de kits. */
  get todosFixos(): boolean { return this.componentes.every((g: any) => g.configComponenteKit?.modalidadeQuantidade === 'FIXA'); }
  /** "200 Sabores Salgados + 100 Docinhos" considerando a quantidade de kits do item. */
  get resumoUnidades(): string {
    const qtde = this.item?.qtde || 1;
    return this.componentes
      .map((g: any) => ({nome: g.nome, unidades: RegrasDeComponenteKit.selecao(g, this.item.componentesKit)?.qtdeUnidades}))
      .filter(r => r.unidades)
      .map(r => `${r.unidades * qtde} ${r.nome}`).join(' + ');
  }
  /** Por grupo, o que já foi escolhido multiplicado pelos kits: "150 Frango · 150 Carne" e, se faltar, "faltam 30". */
  get escolhidos(): {grupo: string; texto: string}[] {
    const qtde = this.item?.qtde || 1;
    const multiplos = (this.produto?.camposAdicionais || []).filter(permiteMultiplaEscolha);
    return this.componentes.map((g: any) => {
      const lista = this.item.adicionais?.['lista' + multiplos.indexOf(g)] || {};
      const escolhas = Object.keys(lista).filter(k => k.startsWith('opcao_') && lista[k]?.selecionada && lista[k].qtde > 0).map(k => lista[k]);
      const unidades = RegrasDeComponenteKit.selecao(g, this.item.componentesKit)?.qtdeUnidades || 0;
      const faltam = unidades - escolhas.reduce((s, e) => s + e.qtde, 0);
      const partes = escolhas.map(e => `${e.qtde * qtde} ${e.opcao?.nome}`);
      if (faltam > 0) partes.push(`faltam ${faltam * qtde}`);
      return {grupo: g.nome, texto: partes.join(' · ')};
    }).filter(l => l.texto);
  }
  ngOnChanges(): void {
    if (!this.item || !this.config) return;
    if (this.item.qtdeUnidadesKit == null && this.config.modalidadeQuantidade === 'ESCOLHIDA_PELO_CLIENTE')
      this.item.qtdeUnidadesKit = this.config.qtdeMinimaCompra;
    this.item.atualizeTotal?.();
  }
  tamanho(t: any): void { this.item.produtoTamanho = t; this.item.qtdeUnidadesKit = t.qtdeUnidades; this.atualize(); }
  passo(delta: number): void { this.item.qtdeUnidadesKit += delta * this.config.incrementoCompra; this.atualize(); }
  quantidade(o: any): number { return this.lista['opcao_' + o.id]?.qtde || 0; }
  definir(o: any, qtde: number): void {
    this.lista['opcao_' + o.id] = {opcao: o, qtde, selecionada: qtde !== 0, valorTotal: qtde * (o.valor || 0)};
    this.lista.totalSelecionado = this.total;
    this.atualize();
  }
  passoSabor(o: any, delta: number): void {
    const atual = this.quantidade(o), minimo = Math.max(this.config.qtdeMinimaPorSabor, o.qtdeMinima || 1), passo = this.passoRapido;
    let proxima: number;
    if (delta > 0) proxima = Math.min(atual === 0 ? Math.max(minimo, passo) : atual + passo, atual + this.restante);
    else { const alvo = atual - passo; proxima = alvo < minimo ? (atual > minimo ? minimo : 0) : alvo; }
    if (proxima < 0 || proxima === atual) return;
    this.definir(o, proxima);
  }
  completar(o: any): void { this.definir(o, Math.max(0, this.item.qtdeUnidadesKit - this.total + this.quantidade(o))); }
  dividir(): void {
    const selecionadas = this.opcoes.filter(o => this.quantidade(o) > 0);
    if (!selecionadas.length) { this.aviso = 'Marque os sabores antes de dividir.'; return; }
    const base = Math.floor(this.item.qtdeUnidadesKit / selecionadas.length);
    if (selecionadas.some(o => base < Math.max(this.config.qtdeMinimaPorSabor, o.qtdeMinima || 1))) {
      this.aviso = 'Escolha menos sabores para respeitar o mínimo por sabor.'; return;
    }
    selecionadas.forEach((o, i) => this.definir(o, base + (i < this.item.qtdeUnidadesKit % selecionadas.length ? 1 : 0)));
  }
  atualize(): void { this.aviso = ''; this.item.atualizeTotal?.(); this.alterou.emit(); }
}
